export const hasPremiumAccess = (type: string | null | undefined) =>
  type === 'trial' || type === 'paid'

export const premiumMessages = {
  card_images: 'Добавление изображений в новые карточки доступно по подписке.',
  custom_audio: 'Загрузка своей озвучки карточек доступна по подписке.',
  scheduled_review: 'Повторение по расписанию доступно по подписке.',
  additional_reminders: 'Дополнительные напоминания доступны по подписке.',
  open_favorite_card_group: 'Изучение избранных наборов доступно по подписке.',
  open_favorite_category: 'Открытие избранных папок доступно по подписке.',
} as const
